import { FC, useEffect, useState } from "react";
import Card from "antd/es/card/Card";
import { Button, Input, message, Form} from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TokenValid } from "../../shared/types/request/tokenvalid.model";
import { useIsTokenValid } from "../../shared/services/security/security.service";
import { useNewForgetPassword } from "../../shared/services/forgetpassword/forgetpassword.service";
import { NewForgetPasswordRequest } from "../../shared/types/request/newforgetpassword.model";

const NewForgetPassword : FC = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    
    function retourVersConnexion() {
        navigate("/connexion");
    }

    const[tokenRequest, setTokenRequest] = useState<TokenValid>();
    
    const {dataToken} = useIsTokenValid(tokenRequest);
    
    useEffect(() => {
        if(localStorage.getItem("username") && localStorage.getItem("token")){
            const request: TokenValid = {
                username: localStorage.getItem("username") || "",
                token: localStorage.getItem("token") || ""
            };
            setTokenRequest(request);
        }
    }, [])
    
    useEffect(() => {
        if(dataToken){
            navigate("/espaceuser");
        }
    }, [dataToken])

    const[messageApi, contextHolder] = message.useMessage();
    const[formValues, setFormValues] = useState<NewForgetPasswordRequest>();

    const onFinish = (values: any) => {
        const request : NewForgetPasswordRequest = {
            token: searchParams.get("token") || "",
            password: values.password
        };
        setFormValues(request);
    };

    const{data, isLoading, error} = useNewForgetPassword(formValues);

        useEffect(() =>{
        if(error && error.response.data.erreur){
            messageApi.error(error.response.data.erreur);
        }else{
            if(error)
            {
                messageApi.error(error.message);
            }
        }
        setFormValues(undefined);
    }, [error])

    useEffect(() => {
        if(data && data.ok){
            messageApi.success(data.ok);
            navigate("/connexion");
        }
        setFormValues(undefined);
    }, [data])

    return(
        <Card title={<span style={{ textAlign: "center" }}>Entrez votre nouveau mot de passe</span>} variant="borderless" className="responsive-card">
            {contextHolder}
            <div style={{paddingLeft:"5%", paddingRight:"30%"}}>
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Mot de passe"
                        name="password"
                        rules={[
                            {required: true, message: "Mot de passe requis"},
                            {min: 6, message: "Minimum 6 caractères"}
                        ]}
                        hasFeedback
                    >
                        <Input.Password placeholder="Mot de passe" />
                    </Form.Item>


                    <Form.Item
                        label="Confirmer le mot de passe"
                        name="confirmPassword"
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                            {required: true, message: "Confirmez le mot de passe"},
                            ({getFieldValue}) => ({
                                validator(_, value){
                                    if(!value || getFieldValue("password") === value){
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error("Les mots de passe ne correspondent pas")
                                    )
                                }
                            })
                        ]}
                    >
                        <Input.Password placeholder="Confirmer le mot de passe" />
                    </Form.Item>
                    <Button type="primary" loading={isLoading} htmlType="submit">
                        Valider
                    </Button>
                </Form>
            </div>
            <Button onClick={retourVersConnexion} style={{ marginTop: "50px" }}>Retour</Button>
        </Card>
    );
}

export default NewForgetPassword;